import React, { useState } from 'react'
import styled from '@emotion/styled'
import { useQueryParams } from 'raviger'

import { colors } from 'Constants'

import { Flex } from 'lese'

import { H2, Text } from 'Components/shared/Typography'

const Switcher = styled(Flex)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${({ isSwitched, formWidth }) => (isSwitched ? '0' : formWidth)};
  background-color: ${colors.secondary};
  color: ${colors.textOnPrimary};
  width: ${({ formWidth }) => formWidth};
  height: 100%;
  padding: 0 32px;
  box-sizing: border-box;
  transition: 0.2s left;
`
Switcher.defaultProps = { column: true, separation: '24px', xAlign: true, yAlign: true }

const SwitcherBackground = styled.picture`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.15;
  mix-blend-mode: overlay;
  pointer-events: none;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export default props => {
  const [{ setupAccount }] = useQueryParams()
  const [isSwitched] = useState(setupAccount === 'true')
  return (
    <Switcher isSwitched={isSwitched} {...props}>
      <SwitcherBackground>
        <source type="image/webp" srcSet="/login-overlay.webp" />
        <img src="/login-overlay.jpg" alt="" />
      </SwitcherBackground>
      <H2>Welcome{!isSwitched && ' Back'}!</H2>
      <Text align>
        {isSwitched &&
          'To get started with the CAREMINDr App Admin, please enter the information an admin gave you. This form can also be used for resetting your password after a request.'}
        {!isSwitched &&
          'To get back into the App Admin, please login with your information on the left.'}
      </Text>
    </Switcher>
  )
}
